import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import util from 'util';
import constClass from '../../Constants/Constants';
// import queryString from 'query-string';
import Loading from '../Loading/Loading';
import CommonBooking from '../Common/common_booking';
import QRCodeScannerBooking from '../Common/QRCodeScanner_booking';
import Modal from 'react-modal';
import CloseImg from '../Images/close.svg';
import Common from '../Common/common';
import QRCode from "react-qr-code";

Modal.setAppElement("#root");

const BookingQRRead = ({ page, siteId, lineId, book_id, book_set_id, category_id, settings, getReceptdata, submitCurrentbooking }) => {
  const history = useHistory();
  const [receptData, setReceptData] = useState(null)
  const [receptCategory, setReceptCategory] = useState({ category_id: null, chk: false })
  const [nowDate, setNowDate] = useState(null);
  const [priceList, setPriceList] = useState({ price: 0, count: 0 });
  const [values, setValues] = useState({
    category_id: null,
    book_date: null,
    recept: null,
    recept_check: false,
  });
  const [scanning, setScanning] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");
  const [scanMessage, setScanMessage] = useState("");
  const [receptError, setReceptError] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [qrData, setQrData] = useState(null);

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    content: {
      position: "absolute",
      left: '0.5rem',
      right: '0.5rem',
      top: '10vw',
      bottom: 'auto',
      marginTop: '0.5rem',
      borderRadius: "0rem",
      padding: "0px",
      height: "auto"
    }
  };

  const getQrData = useCallback(async () => {
    const qr_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/line/qrdata/${siteId}/`, { site_id: siteId, line_id: lineId })).data;
    setQrData(qr_data);
  }, [siteId, lineId]);

  const refreshData = useCallback(async () => {
    const params = {
      site_id: siteId,
      line_id: lineId,
      book_date: new Date()
    }
    const bookingPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search_detail/`, params);
    const detail_lst = (await bookingPromise).data;
    //対象データ取得 （QRが有ればQR優先）
    var recept = await getReceptdata(detail_lst, category_id);
    //対象データ取得 (画面遷移時に指定したデータ)
    var recept2 = (book_id && book_set_id) ? detail_lst.find(x => x.book_id === book_id && x.book_set_id === book_set_id) : null;
    var recept_error = false;
    if (!recept && !recept2) {
      // どちらも対象が無ければエラー
      recept_error = true;
    } else if (recept2 && (!recept || recept.booking_status !== constClass.STATUS.FIN)) {
      // 受付中・受付予定どちらも無ければ画面遷移時のデータを表示
      recept = recept2;
    }
    var price = recept ? recept.price : 0;
    var count = recept ? recept.count : 0;
    if (!isMounted) return;
    console.log(recept);
    setReceptData({
      ...recept,
      view_receipt_num: recept && recept.t_booking ? recept.t_booking.receipt_num : null,
      view_start_time: recept ? CommonBooking.strTotime(recept.view_start_time) : null,
      view_book_date_ja: recept ? moment(recept.book_date).format('YYYY年MM月DD日') : null,
      view_count: recept ? recept.count : null
    });
    setPriceList({
      price,
      count,
    });
    setNowDate(moment().format('HH:mm:ss.SS'));
    setValues({
      book_date: recept ? recept.book_date : null,
      book_id: book_id,
      book_set_id: book_set_id,
      category_id: category_id,
      status: null,
      recept_check: page === constClass.RECEPT ? true : false,
    });
    setReceptError(recept_error);
    // 二次元コードを読み取っていれば受付処理を実行（state更新のためuseEffectにて実行）
    if (!recept_error && category_id !== null && category_id !== undefined && page === constClass.RECEPTQR) {
      setReceptCategory({ category_id: category_id, chk: false });
    }
  }, [siteId, lineId, book_id, book_set_id, category_id, page, getReceptdata, isMounted]);

  const checkReady = useCallback(() => {
    return (siteId !== null && siteId !== undefined) && lineId && (receptData || receptError);
  }, [siteId, lineId, receptData, receptError]);

  useEffect(() => {
    setIsMounted(true);
    getQrData();
    async function fetchData() {
      await refreshData();
    }
    fetchData();

    return () => {
      // https://zenn.dev/maktub_bros/articles/3366d053275d60
      // React useEffect メモリーリーク防止 Tip
      setIsMounted(false);
    }

  }, [getQrData, refreshData]);

  useEffect(() => {
    var intervalId;
    if ([constClass.RECEPT].includes(page)) {
      intervalId = setInterval(() => {
        const date = moment().format('HH:mm:ss.SS');
        setNowDate(date);
      }, 100);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [page]);

  const viewTicket = useCallback((status, id = null, no = null) => {
    submitCurrentbooking(id, no, constClass.RECEPT);
  }, [submitCurrentbooking]);

  //受付処理
  const submitRecept = useCallback(async (status, category_id, recept) => {
    try {
      var data = {
        site_id: siteId,
        line_id: lineId,
        book_id: receptData.book_id,
        book_set_id: receptData.book_set_id,
        status: status,
        detail: recept,
      }
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/status/${data.book_id}/`, data);

      setReceptData({ ...receptData, booking_status: status })
      setValues({
        category_id,
        recept: { ...recept, booking_status: status },
      });
      viewTicket(status, receptData.book_id, receptData.book_set_id);
    } catch (error) {
      console.log(util.inspect(error));
      if (error.response.data && error.response.data.msg) {
        alert('エラーが発生しました。\n' + error.response.data.msg);
      }
    }
  }, [siteId, lineId, receptData, viewTicket]);

  const handleRecept = useCallback(async (qr_category_id,qr_shop_id, chk) => {
    var status = receptData.booking_status;
    qr_category_id = Number(qr_category_id);
    qr_shop_id = Number(qr_shop_id);
    if (status !== constClass.STATUS.FIN && receptData.category_id !== qr_category_id) {
      if (chk) {
        alert("予約したカテゴリと異なります。予約を変更またはキャンセル後再登録してください。");
      } else {
        setReceptError(true);
      }
      return;
    }
    if (status !== constClass.STATUS.FIN && receptData.shop_id !== qr_shop_id) {
      if (chk) {
        alert("予約した支所と異なります。予約を変更またはキャンセル後再登録してください。");
      } else {
        setReceptError(true);
      }
      return;
    }
    if (status === constClass.STATUS.FIN) {
      if (receptData.category_id === qr_category_id) {
        setReceptCategory({ category_id: null, chk: false });
        viewTicket(status, receptData.book_id, receptData.book_set_id);
        return;
      }
    } else {
      if (!window.confirm(`受付します。よろしいでしょうか？`)) {
        setReceptCategory({ category_id: null, chk: false });
        return;
      } else {
        status = constClass.STATUS.FIN;
      }
    }

    //ステータス変更処理
    submitRecept(status, qr_category_id, receptData);
    setReceptCategory({ category_id: null, chk: false });
  }, [receptData, submitRecept, viewTicket]);

  useEffect(() => {
    if (receptCategory.category_id) {
      handleRecept(receptCategory.category_id, receptCategory.chk);
    }
  }, [receptCategory, handleRecept]);

  const scanQR = () => {
    setScanMessage("");
    setScanning(true);
  }

  useEffect(() => {
    if (scanning && qrCodeData) {
      try {
        const cd = Common.getCdFromQrString(qrCodeData);
        const sp = Common.getSpFromQrString(qrCodeData);
        if (cd) {
          setScanning(false);
          setQrCodeData("");
          setScanMessage("");
          handleRecept(cd, sp, true);
        } else {
          setScanMessage("読み取りに失敗しました。再度読み取りをお願いします。");
        }
      } catch (error) {
        console.log(error);
        setScanMessage("読み取りに失敗しました。再度読み取りをお願いします。");
      }
    }
  }, [scanning, qrCodeData, handleRecept]);

  const renderTicket = () => {
    return (

      <React.Fragment>
        {receptData.booking_status === constClass.STATUS.FIN &&
          <div className="row mb-3">
            <div className='col-12 py-3 bg-green text-white text-center'>
              この画面を受付で提示してください。
            </div>
          </div>}
        <div className="row mb-2 bg-white py-3">
          <div className="col-12">
            <h4 className='py-3 text-center text-green'>{nowDate}</h4>
            <div className='row'><div className='col-auto px-1 mx-1 text-green'>[受付番号]</div><div className='col px-1 mx-1'>{receptData.view_receipt_num}</div></div>
            <div className='row'><div className='col-auto px-1 mx-1 text-green'>[カテゴリ]</div><div className='col px-1 mx-1'>{receptData.category_name}</div></div>
            <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　日付　]</div><div className='col px-1 mx-1'>{receptData.view_book_date_ja}</div></div>
            <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　時間　]</div><div className='col px-1 mx-1'>{CommonBooking.strTotime(receptData.start_time)} ～ {CommonBooking.strTotime(receptData.end_time)}</div></div>
            <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　数量　]</div><div className='col px-1 mx-1'>{receptData.view_count}</div></div>
            {Number(priceList.price) !== 0 && <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　料金　]</div><div className='col px-1 mx-1'>{priceList.price} 円</div></div>}
          </div>
        </div >
        <div className="row mx-0 pt-3 pb-3">
          <div className="col font-weight-bold text-center">
            <button
              className={`btn btn-primary py-2 px-1 w-75`}
              onClick={() => {
                submitCurrentbooking(null, null, null);
                history.replace(`/${siteId}/`);
              }}>
              メニューに戻る
            </button>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderQR = () => {
    return (
      <React.Fragment>
        {scanning &&
          <Modal isOpen={scanning} style={modalStyle} onRequestClose={() => setScanning(false)}>
            <div className="container-fluid section-white m-0 py-2 vh-50 overflow-auto">
              <div className="row mx-0 px-3-env text-left form-group">
                <div className="col px-0 align-self-center">
                  <span>二次元コード読み取り</span>
                </div>
                <div className="col-auto px-0 align-self-start">
                  <div className="text-right px-0" onClick={() => setScanning(false)}><img className="icon" src={CloseImg} alt="閉じる" /></div>
                </div>
              </div>
              <div className="row mx-0 px-3-env mt-3 mb-2 text-left">
                <div className="col px-0 align-self-center">
                  <QRCodeScannerBooking
                    siteId={siteId}
                    setQrCodeData={setQrCodeData}
                    scanning={scanning}
                  />
                </div>
              </div>
              <div className="row mx-0 px-3-env mt-2 mb-3 text-center">
                <div className="col px-0 align-self-center text-danger">{scanMessage}</div>
              </div>
              <div className="row mx-0 px-3-env pt-1 pb-3">
                <div className="col-12 text-center p-0">
                  <button
                    className="btn btn-link text-body"
                    onClick={() => setScanning(false)}>
                    閉じる
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        }
        {Common.getSettingValue(settings, 'BOOKING_QR_READ', '0') === constClass.FLAG.OFF &&
        (constClass.STATUS_RECEPTOK.includes(receptData.booking_status) && receptCategory.category_id === null) &&
          <div className="row mb-3">
            <div className='col-12 p-2 bg-green text-white text-center'>
              受付の二次元コードを読み取ってください
            </div>
          </div>
        }
        <div className="row mb-3 bg-white">
          <div className="col-12 p-2 text-left">
            {Common.getSettingValue(settings, 'BOOKING_QR_READ', '0') === constClass.FLAG.OFF &&
            (constClass.STATUS_RECEPTOK.includes(receptData.booking_status) && receptCategory.category_id === null) &&
              <div className="row mx-3 mb-3pt-2 pb-2">
                <div className='col text-center'>
                  <button
                    className={`btn btn-active w-100 h-100 py-2 px-2`}
                    onClick={e => { scanQR() }}>
                    <h4 className="mb-0 font-weight-bold">二次元コード読取</h4>
                  </button>
                </div>
              </div>
            }
            {constClass.STATUS.FIN === receptData.booking_status &&
              <div className="row mx-0 px-3-env pt-2 pb-1 bg-green text-white text-center">
                <div className='col text-center h5'>受付済</div>
              </div>
            }
            {receptData && <React.Fragment>
              <div className="row mx-3 my-3 px-0-env bg-white">
                <div className="col-12">
                  <div className='row'><div className='col-auto px-1 mx-1 text-green'>[受付番号]</div><div className='col px-1 mx-1'>{receptData.view_receipt_num}</div></div>
                  <div className='row'><div className='col-auto px-1 mx-1 text-green'>[カテゴリ]</div><div className='col px-1 mx-1'>{receptData.category_name}</div></div>
                  <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　日付　]</div><div className='col px-1 mx-1'>{receptData.view_book_date_ja}</div></div>
                  <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　時間　]</div><div className='col px-1 mx-1'>{CommonBooking.strTotime(receptData.start_time)} ～ {CommonBooking.strTotime(receptData.end_time)}</div></div>
                  <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　数量　]</div><div className='col px-1 mx-1'>{receptData.view_count}</div></div>
                  {Number(priceList.price) !== 0 && <div className='row'><div className='col-auto px-1 mx-1 text-green'>[　料金　]</div><div className='col px-1 mx-1'>{priceList.price} 円</div></div>}
                </div>
              </div >
              {Common.getSettingValue(settings, 'BOOKING_QR_READ', '0') === constClass.FLAG.ON &&
              qrData && qrData.length > 0 && qrData.map((qr, index) => (
                <div key={index} className='pb-4'>
                  <div className='col-12 py-2 text-center'>
                    <QRCode className="qr-img" size={200} value={qr.qr_data} />
                  </div>
                </div>
              ))}
              <hr />
            </React.Fragment>
            }
            {[constClass.STATUS.FIN].includes(receptData.booking_status) &&
              <div className="row mx-0 my-3 pt-2 pb-3">
                <div className="col-12 text-left">
                  <div className="row mx-0 pt-2 pb-1 ">
                    <div className='col text-center'>
                      <button
                        className={`btn btn-active w-100 h-100 py-2 px-2`}
                        onClick={e => viewTicket(receptData.booking_status, receptData.book_id, receptData.book_set_id)}>
                        <h4 className="mb-0 font-weight-bold">チケット表示</h4>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderErr = () => {
    return (
      <React.Fragment>
        <div>
          <div className="row mx-0 px-3-env pt-2 pb-1 bg-green text-white">
            <div className='col-12 py-3 h5 text-center'>対象の予約がございません</div>
          </div>
        </div>
      </React.Fragment>
    );
  }


  return (
    checkReady() ?
      <React.Fragment>
        {receptError ?
          renderErr()
          :
          <div className="row mx-3 my-3 px-0-env">
            <div className="col px-2">
              {(page === constClass.RECEPTQR && !values.recept_check) &&
                renderQR()
              }
              {(page === constClass.RECEPT || values.recept_check) &&
                renderTicket()
              }
            </div>
          </div>}
      </React.Fragment>
      : <Loading />
  )

}
export default BookingQRRead;
